import { graphql, useFragment } from 'react-relay';
import PropTypes from 'prop-types';

// components
import { SbSharedRefineMenuMultiSelectList } from '../SbSharedRefineMenuMultiSelect/SbSharedRefineMenuMultiSelectList.jsx';

const itemSearchFragment = graphql`
    fragment SbSharedRefineMenuFilterStyle_itemSearch on ItemSearchQueryConnection {
        ...SbSharedRefineMenuMultiSelectList_itemSearch
    }
`;
export const SbSharedRefineMenuFilterStyle = ({
    itemSearch: itemSearchRef,
    collapsedItemCount,
    filterName,
    shouldUseExpandableList,
    values,
    trackingOptions,
}) => {
    const itemSearch = useFragment(itemSearchFragment, itemSearchRef);
    return (
        <SbSharedRefineMenuMultiSelectList
            itemSearch={itemSearch}
            collapsedItemCount={collapsedItemCount}
            filterName={filterName}
            shouldUseExpandableList={shouldUseExpandableList}
            values={values}
            trackingOptions={trackingOptions}
        />
    );
};

SbSharedRefineMenuFilterStyle.propTypes = {
    itemSearch: PropTypes.object.isRequired,
    collapsedItemCount: PropTypes.number,
    filterName: PropTypes.string.isRequired,
    shouldUseExpandableList: PropTypes.bool,
    values: PropTypes.array.isRequired,
    trackingOptions: PropTypes.object,
};
